import { Injectable, Inject, forwardRef,} from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository,Raw, getConnection } from 'typeorm';
import { ChayuthaEntity } from './kchayutha.entity';
import { sendFCMNotifications, sendTextLocalSMS } from '../shared/mobileOTP';
import { ChayuthaDTO, DeleteDTO, StatusDto } from './dto/kchayutha.dto';
import { AllChayuthaResponseModel, ChayuthaResponseModel, SingleChayuthaResponseModel } from './dto/kchayutha-response-model';
import { ProfileService } from '../profile/profile.service';


@Injectable()
export class ChayuthaService {
  constructor(
    @InjectRepository(ChayuthaEntity)
    private chRep: Repository<ChayuthaEntity>,
    @Inject(forwardRef(()=>ProfileService))
    private profileService: ProfileService,
  ) {}

  async sendSMS(mobileNo:string, text: string, id:string) {
    return await sendTextLocalSMS(mobileNo, text, id)
    .then(() => {      
    console.log('sms sent successufully');
    return true;
    })
    .catch((err) => {
    console.log('error in sending sms ', err);
    return false;
    });
  }

  async sendNotify(text) {
    return await sendFCMNotifications(text)
    .then(() => {      
      console.log('notification sent successufully');
      return true;
    })
    .catch((err) => {
      console.log('error in sending notification ', err);
      return false;
    });
  }

  
  async createChayutha(queryParams,cyDto:ChayuthaDTO): Promise<ChayuthaResponseModel> {
    cyDto.status  = true;
      const response = new ChayuthaResponseModel();
      try {
              if(queryParams.apiVersion == 1) {
               
                const savedWelfare = await this.chRep.save(cyDto);
                
                  
                  if (savedWelfare) {
                    response.status = true;
                    response.data = savedWelfare;
                    response.statusCode = 50000;
                    response.internalMessage = 'Record created successfully';
                    response.intlCode = 11100;
                  } else {
                    throw new ErrorResponse(11106, 'Record not created');
                  }
                } else {
                  const savedWelfare = await this.chRep.save(cyDto);
                  if (savedWelfare) {
                    response.status = true;
                    response.data = savedWelfare;
                    response.statusCode = 50000;
                    response.internalMessage = 'Record created successfully';
                    response.intlCode = 11100;
                  } else {
                    throw new ErrorResponse(11106, 'Record not created');
                  }
              }
          
          return response;
      }
     
      catch (error) {
          throw error;
      }
  
  }  
  

  async updateChayutha(queryParams, cyDto:ChayuthaDTO, request:Request): Promise<SingleChayuthaResponseModel> {
    const response = new SingleChayuthaResponseModel();
    try {
      const oldData = await this.chRep.findOne({
        where:{Id:cyDto.Id}
      })
      if(cyDto.name) {
        cyDto.name = cyDto.name
      } else {
        cyDto.name = oldData.name
      }
      if(cyDto.fatheOrHusbandName) {
        cyDto.fatheOrHusbandName = cyDto.fatheOrHusbandName
      } else {
        cyDto.fatheOrHusbandName = oldData.fatheOrHusbandName
      }
      if(cyDto.dod) {
        cyDto.dod = cyDto.dod
      } else {
        cyDto.dod = oldData.dod
      }
      if(cyDto.causeOfDeath) {
        cyDto.causeOfDeath = cyDto.causeOfDeath
      } else {
        cyDto.causeOfDeath = oldData.causeOfDeath
      }
      if(cyDto.nomineeName) {
        cyDto.nomineeName = cyDto.nomineeName
      } else {
        cyDto.nomineeName = oldData.nomineeName
      }
      if(cyDto.familyMember1) {
        cyDto.familyMember1 = cyDto.familyMember1
      } else {
        cyDto.familyMember1 = oldData.familyMember1
      }
      if(cyDto.familyMember2) {
        cyDto.familyMember2 = cyDto.familyMember2
      } else {
        cyDto.familyMember2 = oldData.familyMember2
      }
      if(cyDto.familyMember3) {
        cyDto.familyMember3 = cyDto.familyMember3
      } else {
        cyDto.familyMember3 = oldData.familyMember3
      }
      if(cyDto.familyMember4) {
        cyDto.familyMember4 = cyDto.familyMember4
      } else {
        cyDto.familyMember4 = oldData.familyMember4
      }
      if(cyDto.streetName) {
        cyDto.streetName = cyDto.streetName
      } else {
        cyDto.streetName = oldData.streetName
      }
      if(cyDto.village) {
        cyDto.village = cyDto.village
      } else {
        cyDto.village = oldData.village
      }
      if(cyDto.mandal) {
        cyDto.mandal = cyDto.mandal
      } else {
        cyDto.mandal = oldData.mandal
      }
      if(cyDto.mobileNo) {
        cyDto.mobileNo = cyDto.mobileNo
      } else {
        cyDto.mobileNo = oldData.mobileNo
      }
      if(cyDto.aadharNo) {
        cyDto.aadharNo = cyDto.aadharNo
      } else {
        cyDto.aadharNo = oldData.aadharNo
      }
      if(cyDto.villageHeadName) {
        cyDto.villageHeadName = cyDto.villageHeadName
      } else {
        cyDto.villageHeadName = oldData.villageHeadName
      }
      if(cyDto.mandalHeadName) {
        cyDto.mandalHeadName = cyDto.mandalHeadName
      } else {
        cyDto.mandalHeadName = oldData.mandalHeadName
      }
      cyDto.updatedUser = cyDto.updatedUser;
      let finaObj = {
        name:cyDto.name,
        fatheOrHusbandName:cyDto.fatheOrHusbandName,
        dod:cyDto.dod,
        causeOfDeath:cyDto.causeOfDeath,
        nomineeName:cyDto.nomineeName,
        familyMember1:cyDto.familyMember1,
        familyMember2:cyDto.familyMember2,
        familyMember3:cyDto.familyMember3,
        familyMember4:cyDto.familyMember4,
        streetName:cyDto.streetName,
        village:cyDto.village,
        mandal:cyDto.mandal,
        mobileNo:cyDto.mobileNo,
        aadharNo:cyDto.aadharNo,
        villageHeadName:cyDto.villageHeadName,
        mandalHeadName:cyDto.mandalHeadName,
        updatedUser:cyDto.updatedUser
      }
      if(queryParams.apiVersion == 1) {
        const updatePostType = await this.chRep.update(cyDto.Id, finaObj);       
        const welfareRespone = await this.chRep.findOne({
          where:{Id:cyDto.Id}
        });
        if (welfareRespone) {
          const user = await this.profileService.getUserByUId(welfareRespone.updatedUser);
          if(user){
            var pic = user.profilePic;
          } else {
            var pic = '';
          }
          const final = {
            Id: welfareRespone.Id,
            name:welfareRespone.name,
            fatheOrHusbandName:welfareRespone.fatheOrHusbandName,
            dod:welfareRespone.dod,
            causeOfDeath: welfareRespone.causeOfDeath,
            nomineeName: welfareRespone.nomineeName,
            familyMember1: welfareRespone.familyMember1,
            familyMember2: welfareRespone.familyMember2,
            familyMember3: welfareRespone.familyMember3,
            familyMember4: welfareRespone.familyMember4,
            streetName: welfareRespone.streetName,
            village: welfareRespone.village,
            mandal: welfareRespone.mandal,
            mobileNo: welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            villageHeadName:welfareRespone.villageHeadName,
            mandalHeadName:welfareRespone.mandalHeadName,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : '',
            welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new'
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'Record updated';
          response.intlCode = 11108;
          response.data = final;
        } else {
          throw new ErrorResponse(99998, 'Record update failed');
        }
      } else  {
        const updatePostType = await this.chRep.update(cyDto.Id, finaObj);       
        const welfareRespone = await this.chRep.findOne({
          where:{Id:cyDto.Id}
        });
        if (welfareRespone) {
          const user = await this.profileService.getUserByUId(welfareRespone.updatedUser);
          if(user){
            var pic = user.profilePic;
          } else {
            var pic = '';
          }
          const final = {
            Id: welfareRespone.Id,
            name:welfareRespone.name,
            fatheOrHusbandName:welfareRespone.fatheOrHusbandName,
            dod:welfareRespone.dod,
            causeOfDeath: welfareRespone.causeOfDeath,
            nomineeName: welfareRespone.nomineeName,
            familyMember1: welfareRespone.familyMember1,
            familyMember2: welfareRespone.familyMember2,
            familyMember3: welfareRespone.familyMember3,
            familyMember4: welfareRespone.familyMember4,
            streetName: welfareRespone.streetName,
            village: welfareRespone.village,
            mandal: welfareRespone.mandal,
            mobileNo: welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            villageHeadName:welfareRespone.villageHeadName,
            mandalHeadName:welfareRespone.mandalHeadName,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : '',
            welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new'
          }
          response.status = true;
          response.statusCode = 50000;
          response.internalMessage = 'Record updated';
          response.intlCode = 11108;
          response.data = final;
        } else {
          throw new ErrorResponse(99998, 'Record update failed');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }    
  }

  async getAllChayutha(queryParams,userId, request:Request): Promise<AllChayuthaResponseModel>{
    const response = new AllChayuthaResponseModel();
    try{
      const finalData: any[] = [];
      const user = await this.profileService.getUserByUId(userId);
      if(user){
        var pic = user.profilePic;
      } else {
        var pic = '';
      }
      if (queryParams.apiVersion == 1) {
        if(queryParams.type == 0) {
          var welfare = await this.chRep.find({
            where: [{status: true,createdUser:userId},
              {status:true}],
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10 
          });
        } else if(queryParams.type == 1) {
          var welfare = await this.chRep.find({
            where: [{status: true,createdUser:userId},
              {status:true},
            {currentStatus:'new',status:true},
            {currentStatus:'Yet to start',status:true}],
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10
          });
        } else if(queryParams.type == 2) {
          var welfare = await this.chRep.find({
            where: [{status: true,createdUser:userId},
              {status:true},
            {currentStatus:'in progress',status:true},
            {currentStatus:'inprogress',status:true}],
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10
          });
        } else if(queryParams.type == 3) {
          var welfare = await this.chRep.find({
            where: [{status: true,createdUser:userId},
              {status:true},
            {currentStatus:'completed',status:true},
            {currentStatus:'closed',status:true}],
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10
          });
        } 
       
        if(!welfare) {
          throw new ErrorResponse(99908,'Data not found')
        }
        const promises = welfare.map(async (welfareRespone) => {
          const user = await this.profileService.getUserByUId(welfareRespone.createdUser);
          return {
            Id: welfareRespone.Id,
            name:welfareRespone.name,
            fatheOrHusbandName:welfareRespone.fatheOrHusbandName,
            dod:welfareRespone.dod,
            causeOfDeath: welfareRespone.causeOfDeath,
            nomineeName: welfareRespone.nomineeName,
            familyMember1: welfareRespone.familyMember1,
            familyMember2: welfareRespone.familyMember2,
            familyMember3: welfareRespone.familyMember3,
            familyMember4: welfareRespone.familyMember4,
            streetName: welfareRespone.streetName,
            village: welfareRespone.village,
            mandal: welfareRespone.mandal,
            mobileNo: welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            villageHeadName:welfareRespone.villageHeadName,
            mandalHeadName:welfareRespone.mandalHeadName,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : '',
            welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new'
          }   
        });   
        const da = await Promise.all(promises);
        da.map((welfareRespone) => {                                   
            finalData.push({
              Id: welfareRespone.Id,
            name:welfareRespone.name,
            fatheOrHusbandName:welfareRespone.fatheOrHusbandName,
            dod:welfareRespone.dod,
            causeOfDeath: welfareRespone.causeOfDeath,
            nomineeName: welfareRespone.nomineeName,
            familyMember1: welfareRespone.familyMember1,
            familyMember2: welfareRespone.familyMember2,
            familyMember3: welfareRespone.familyMember3,
            familyMember4: welfareRespone.familyMember4,
            streetName: welfareRespone.streetName,
            village: welfareRespone.village,
            mandal: welfareRespone.mandal,
            mobileNo: welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            villageHeadName:welfareRespone.villageHeadName,
            mandalHeadName:welfareRespone.mandalHeadName,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.userId,
            userName: welfareRespone.userName,
            profilePic: welfareRespone.profilePic,
            welfareStatus:welfareRespone.welfareStatus                  
            }) 
        }) 
        /* var allDevPosts = await this.welfareRepository.find({
          where:{status:true},
          order: {createdAt: "DESC"}
        });
        if(allDevPosts) {
          var totalDevcnt = allDevPosts.length;
        } else {
          var totalDevcnt = 0;
        }       */        
        response.status = true;
          response.data = finalData; 
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;  
        /* if(totalDevcnt == 0) {
          response.status = true;
          response.data = finalData;  
          response.percentData =  {
            allCount:totalDevcnt,
            newCount:0,
            newPercentage: 0,
            inProgressCount:0,
            inProgressPercentage:0,
            closedCount:0,
            closedPercentage:0
          }
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        } else {          
          var cmptDevPosts = await this.welfareRepository.find({
            where:[{currentStatus:'completed',status:true},
            {currentStatus:'closed',status:true}],
            order: {createdAt: "DESC"}
          });
          if(cmptDevPosts) {
            var cmptDevcnt = cmptDevPosts.length;
          } else {
            var cmptDevcnt = 0;
          }
          var progressDevPosts = await this.welfareRepository.find({
            where:[{currentStatus:'inprogress',status:true},
            {currentStatus:'in progress',status:true}],
            order: {createdAt: "DESC"}
          });
          if(progressDevPosts) {
            var prgrsDevcnt = progressDevPosts.length;
          } else {
            var prgrsDevcnt = 0;
          }          
          var newDevPosts = await this.welfareRepository.find({
            where:[{currentStatus:'new',status:true},
            {currentStatus:'Yet to start',status:true}],
              order: {createdAt: "DESC"}
          });
          if(newDevPosts) {
              var newDevcnt = newDevPosts.length;
          } else {
              var newDevcnt = 0;
          }
          var newPer = newDevcnt == 0? 0 : Math.round((newDevcnt/totalDevcnt)*100);
          var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
          var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
          response.status = true;
          response.data = finalData;
          response.percentData = {
            allCount:totalDevcnt,
            newCount:newDevcnt,
            newPercentage: newPer,
            inProgressCount:prgrsDevcnt,
            inProgressPercentage:inproPer,
            closedCount:cmptDevcnt,
            closedPercentage:cmptPer
          }
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        }   */
      } else  {
        if(queryParams.type == 0) {
          var welfare = await this.chRep.find({
            where: [{status: true,createdUser:userId},
              {status:true}],
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10 
          });
        } else if(queryParams.type == 1) {
          var welfare = await this.chRep.find({
            where: [{status: true,createdUser:userId},
              {status:true},
            {currentStatus:'new',status:true},
            {currentStatus:'Yet to start',status:true}],
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10
          });
        } else if(queryParams.type == 2) {
          var welfare = await this.chRep.find({
            where: [{status: true,createdUser:userId},
              {status:true},
            {currentStatus:'in progress',status:true},
            {currentStatus:'inprogress',status:true}],
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10
          });
        } else if(queryParams.type == 3) {
          var welfare = await this.chRep.find({
            where: [{status: true,createdUser:userId},
              {status:true},
            {currentStatus:'completed',status:true},
            {currentStatus:'closed',status:true}],
            order: { createdAt: 'DESC' },
            skip:queryParams.skip,
            take:10
          });
        } 
       
        if(!welfare) {
          throw new ErrorResponse(99908,'Data not found')
        }
        const promises = welfare.map(async (welfareRespone) => {
          const user = await this.profileService.getUserByUId(welfareRespone.createdUser);
          return {
            Id: welfareRespone.Id,
            name:welfareRespone.name,
            fatheOrHusbandName:welfareRespone.fatheOrHusbandName,
            dod:welfareRespone.dod,
            causeOfDeath: welfareRespone.causeOfDeath,
            nomineeName: welfareRespone.nomineeName,
            familyMember1: welfareRespone.familyMember1,
            familyMember2: welfareRespone.familyMember2,
            familyMember3: welfareRespone.familyMember3,
            familyMember4: welfareRespone.familyMember4,
            streetName: welfareRespone.streetName,
            village: welfareRespone.village,
            mandal: welfareRespone.mandal,
            mobileNo: welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            villageHeadName:welfareRespone.villageHeadName,
            mandalHeadName:welfareRespone.mandalHeadName,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : '',
            welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new'
          }   
        });   
        const da = await Promise.all(promises);
        da.map((welfareRespone) => {                                   
            finalData.push({
              Id: welfareRespone.Id,
            name:welfareRespone.name,
            fatheOrHusbandName:welfareRespone.fatheOrHusbandName,
            dod:welfareRespone.dod,
            causeOfDeath: welfareRespone.causeOfDeath,
            nomineeName: welfareRespone.nomineeName,
            familyMember1: welfareRespone.familyMember1,
            familyMember2: welfareRespone.familyMember2,
            familyMember3: welfareRespone.familyMember3,
            familyMember4: welfareRespone.familyMember4,
            streetName: welfareRespone.streetName,
            village: welfareRespone.village,
            mandal: welfareRespone.mandal,
            mobileNo: welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            villageHeadName:welfareRespone.villageHeadName,
            mandalHeadName:welfareRespone.mandalHeadName,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.userId,
            userName: welfareRespone.userName,
            profilePic: welfareRespone.profilePic,
            welfareStatus:welfareRespone.welfareStatus                  
            }) 
        }) 
        /* var allDevPosts = await this.welfareRepository.find({
          where:{status:true},
          order: {createdAt: "DESC"}
        });
        if(allDevPosts) {
          var totalDevcnt = allDevPosts.length;
        } else {
          var totalDevcnt = 0;
        }       */        
        response.status = true;
          response.data = finalData; 
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;  
        /* if(totalDevcnt == 0) {
          response.status = true;
          response.data = finalData;  
          response.percentData =  {
            allCount:totalDevcnt,
            newCount:0,
            newPercentage: 0,
            inProgressCount:0,
            inProgressPercentage:0,
            closedCount:0,
            closedPercentage:0
          }
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        } else {          
          var cmptDevPosts = await this.welfareRepository.find({
            where:[{currentStatus:'completed',status:true},
            {currentStatus:'closed',status:true}],
            order: {createdAt: "DESC"}
          });
          if(cmptDevPosts) {
            var cmptDevcnt = cmptDevPosts.length;
          } else {
            var cmptDevcnt = 0;
          }
          var progressDevPosts = await this.welfareRepository.find({
            where:[{currentStatus:'inprogress',status:true},
            {currentStatus:'in progress',status:true}],
            order: {createdAt: "DESC"}
          });
          if(progressDevPosts) {
            var prgrsDevcnt = progressDevPosts.length;
          } else {
            var prgrsDevcnt = 0;
          }          
          var newDevPosts = await this.welfareRepository.find({
            where:[{currentStatus:'new',status:true},
            {currentStatus:'Yet to start',status:true}],
              order: {createdAt: "DESC"}
          });
          if(newDevPosts) {
              var newDevcnt = newDevPosts.length;
          } else {
              var newDevcnt = 0;
          }
          var newPer = newDevcnt == 0? 0 : Math.round((newDevcnt/totalDevcnt)*100);
          var inproPer = prgrsDevcnt == 0?0:Math.round((prgrsDevcnt/totalDevcnt)*100);
          var cmptPer = cmptDevcnt == 0?0:Math.round((cmptDevcnt/totalDevcnt)*100);
          response.status = true;
          response.data = finalData;
          response.percentData = {
            allCount:totalDevcnt,
            newCount:newDevcnt,
            newPercentage: newPer,
            inProgressCount:prgrsDevcnt,
            inProgressPercentage:inproPer,
            closedCount:cmptDevcnt,
            closedPercentage:cmptPer
          }
          response.statusCode = 50000;
          response.internalMessage = 'Data retrived successfully';
          response.intlCode = 11108;
        }   */
      }
      return response;
    }catch( err) {
      throw err;
      }
  }

  async getChayuthaById(queryParams, welfareId: number, request:Request): Promise<SingleChayuthaResponseModel> {
      const response = new SingleChayuthaResponseModel();
      try {
        if (queryParams.apiVersion == 1) {
          const welfareRespone = await this.chRep.findOne({
                      where:{Id:welfareId, status:true}
          });
          if (welfareRespone) {
            const user = await this.profileService.getUserByUId(welfareRespone.createdUser);   
            if(user){
              var pic = user.profilePic;
            } else {
              var pic = '';
            }         
            const final = {
              Id: welfareRespone.Id,
            name:welfareRespone.name,
            fatheOrHusbandName:welfareRespone.fatheOrHusbandName,
            dod:welfareRespone.dod,
            causeOfDeath: welfareRespone.causeOfDeath,
            nomineeName: welfareRespone.nomineeName,
            familyMember1: welfareRespone.familyMember1,
            familyMember2: welfareRespone.familyMember2,
            familyMember3: welfareRespone.familyMember3,
            familyMember4: welfareRespone.familyMember4,
            streetName: welfareRespone.streetName,
            village: welfareRespone.village,
            mandal: welfareRespone.mandal,
            mobileNo: welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            villageHeadName:welfareRespone.villageHeadName,
            mandalHeadName:welfareRespone.mandalHeadName,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : '',
            welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new'                    
            }
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'Record found';
            response.intlCode = 11107;
            response.data = final;
          } else {
            throw new ErrorResponse(99998, 'Record not found');
          }
        } else {
          const welfareRespone = await this.chRep.findOne({
            where:{Id:welfareId, status:true}
          });
          if (welfareRespone) {
            const user = await this.profileService.getUserByUId(welfareRespone.createdUser);     
            if(user){
              var pic = user.profilePic;
            } else {
              var pic = '';
            }        
            const final = {
              Id: welfareRespone.Id,
            name:welfareRespone.name,
            fatheOrHusbandName:welfareRespone.fatheOrHusbandName,
            dod:welfareRespone.dod,
            causeOfDeath: welfareRespone.causeOfDeath,
            nomineeName: welfareRespone.nomineeName,
            familyMember1: welfareRespone.familyMember1,
            familyMember2: welfareRespone.familyMember2,
            familyMember3: welfareRespone.familyMember3,
            familyMember4: welfareRespone.familyMember4,
            streetName: welfareRespone.streetName,
            village: welfareRespone.village,
            mandal: welfareRespone.mandal,
            mobileNo: welfareRespone.mobileNo,
            aadharNo:welfareRespone.aadharNo,
            villageHeadName:welfareRespone.villageHeadName,
            mandalHeadName:welfareRespone.mandalHeadName,
            createdAt:welfareRespone.createdAt,
            userId:welfareRespone.createdUser,
            userName: user!=null?user.firstName:'',
            profilePic: pic != '' ? `${process.env.WORKINGURL}/${pic}` : '',
            welfareStatus:welfareRespone.currentStatus!=null?welfareRespone.currentStatus:'new'                    
            }
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'Record found';
            response.intlCode = 11107;
            response.data = final;
          } else {
            throw new ErrorResponse(99998, 'Record not found');
          }
        }
        return response;
      } catch (error) {
        throw error;
      }
  }   

  async deleteRecord(queryParams,deleteDto:DeleteDTO, request:Request):Promise<ChayuthaResponseModel>{
      const response = new ChayuthaResponseModel();
      try {
        if(queryParams.apiVersion == 1) {
          const welfare =await this.chRep.update(deleteDto.Id,deleteDto);
          if (welfare) {
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'Record deleted successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Record delete failed');
          }
        } else {
          const welfare =await this.chRep.update(deleteDto.Id,deleteDto);
          if (welfare) {
            response.status = true;
            response.statusCode = 50000;
            response.internalMessage = 'Record deleted successfully';
            response.intlCode = 11108;
          } else {
            throw new ErrorResponse(99998, 'Record delete failed');
          }
        }      
        return response;
      } catch (error) {
        throw error;
      }
  }

  async changeWelfareStatus(queryParams,statusDto:StatusDto, request:Request):Promise<SingleChayuthaResponseModel>{
    const response = new SingleChayuthaResponseModel();
    try {
     if(queryParams.apiVersion == 1) {
       await this.chRep.update({Id:statusDto.Id},{currentStatus:statusDto.currentStatus});
        
        const welfare = await this.chRep.findOne({
          where: { Id:statusDto.Id },
        });
        if (welfare) {          
          response.status = true;
          response.data = welfare;
          response.statusCode = 50000;
          response.internalMessage = 'Status updated successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Status update failed');
        }
      } else {
        await this.chRep.update({Id:statusDto.Id},{currentStatus:statusDto.currentStatus});
        
        const welfare = await this.chRep.findOne({
          where: { Id:statusDto.Id },
        });
        if (welfare) {          
          response.status = true;
          response.data = welfare;
          response.statusCode = 50000;
          response.internalMessage = 'Status updated successfully';
          response.intlCode = 11108;
        } else {
          throw new ErrorResponse(99998, 'Status update failed');
        }
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

}


